import { createFileRoute } from '@tanstack/react-router';

import { getFileByName } from '@/app/services/filesService/getFileByName';
import { Forbidden } from '@/view/pages/Forbidden';

export const Route = createFileRoute('/forbidden')({
  component: Forbidden,
  loader: async () => getFileByName('solicitar-acesso'),
});
